import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { getNavigationMenuIcon } from 'content/components/Icon/utils'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

/**
 * LuxKit List Item does not expose surface/background or hover tokens for highlight rows;
 * keep a narrow override so the default neutral hover does not replace the mint treatment.
 */
const MaldivesBundlesListItem = styled(ClickableListItem)`
  min-height: ${rem(50)};
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  border-radius: ${props => props.theme.borderRadius.L};

  &:not(:disabled) {
    ${mediaHoverable} {
      &:hover {
        background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
      }
    }
  }
`

interface Props {
  navItem: App.NavItem
  onNavigate: () => void
}

function NavBarHamburgerMenuMaldivesBundlesBanner(props: Props) {
  const { navItem, onNavigate } = props
  const intl = useIntl()
  const iconName = navItem.sideNavIconName || navItem.iconName
  const Icon = iconName && getNavigationMenuIcon(iconName)

  const newBadgeText = intl.formatMessage({
    id: 'UJeO-rdvZOfzyeTCI0uv',
    defaultMessage: 'New',
    description: 'New badge label for the navigation list items in the navigation bar',
  })

  return (
    <MaldivesBundlesListItem
      size="medium"
      startIcon={Icon ? <NavBarListItemIcon Icon={Icon} /> : undefined}
      overline={navItem.newLabel ? newBadgeText : undefined}
      overlineFormat="uppercase"
      title={navItem.text}
      titleColour="normal-contrast"
      href={navItem.href}
      to={navItem.to}
      onClick={onNavigate}
      rel={navItem.target === '_blank' ? 'noopener noreferrer' : undefined}
      target={navItem.target}
    />
  )
}

export default NavBarHamburgerMenuMaldivesBundlesBanner
